import useAnalytics from 'hooks/useAnalytics'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setOnlineStatus } from 'redux/reducers/appOnlineReducer'

// useConnectionHandler hook
export const useConnectionHandler = () => {
  const dispatch = useDispatch()
  const { setApplicationMode } = useAnalytics()
  const [isInitialized, setIsInitialized] = useState<boolean>(false)

  useEffect(() => {
    function handleOnlineStatus() {
      const status = window.navigator.onLine
      dispatch(setOnlineStatus(status))
      setApplicationMode(status ? 'online' : 'offline')
    }

    handleOnlineStatus() // check status when component mounts

    window.addEventListener('online', handleOnlineStatus)
    window.addEventListener('offline', handleOnlineStatus)

    // Set initialized to true after adding event listeners
    setIsInitialized(true)

    return () => {
      window.removeEventListener('online', handleOnlineStatus)
      window.removeEventListener('offline', handleOnlineStatus)
    }
  }, [])

  return isInitialized
}
